import { ApiError } from "@/services/sdk"

/**
 * Return the user-facing message from SDK errors that append a structured JSON body.
 */
export function parseApiErrorMessage(error: unknown, fallback = "Request failed"): string {
  const raw = error instanceof Error ? error.message : typeof error === "string" ? error : fallback
  const structuredTail = raw.match(/\s+-\s+(\{.*\})$/s)

  if (!structuredTail) return raw

  try {
    const body = JSON.parse(structuredTail[1]) as { error?: unknown; message?: unknown }
    if (typeof body.error === "string" && body.error) return body.error
    if (typeof body.message === "string" && body.message) return body.message
  } catch {
    // Keep the readable prefix when the structured tail is malformed.
  }

  return raw.slice(0, structuredTail.index).trim() || fallback
}

export function isTableNameSaveError(message: string): boolean {
  return (
    /invalid table name/i.test(message) ||
    /table name.*already in use/i.test(message) ||
    /table name cannot be changed/i.test(message)
  )
}

/**
 * Whether an error is the API refusing the caller (HTTP 403).
 */
export function isForbidden(error: unknown): boolean {
  return error instanceof ApiError && error.status === 403
}
